// HKDSE 2015 Paper 1 Knowledge Graph Samples - Part 4
// Questions 16-19 from the complete LaTeX file

export const hkdse2015Samples_part4 = {
  probability: [
    {
      id: 'hkdse2015_probability_01',
      problem: "A box contains $5$ red balls, $6$ yellow balls and $3$ white balls. If $4$ balls are randomly drawn from the box simultaneously, (a) find the probability of drawing exactly $2$ red balls; (b) find the probability of drawing at most $2$ red balls.",
      problemType: "probability_combination",
      difficulty: "intermediate",
      description: "Probability with combinations",
      graphData: {
        nodes: [
          {
            id: "ball_composition",
            name: "Ball Composition",
            type: "concepts",
            description: "Total balls in the box",
            value: "5 red, 6 yellow, 3 white = 14 total",
            importance: 10,
            x: 0, y: -200, z: 0
          },
          {
            id: "total_combinations",
            name: "Total Combinations",
            type: "steps",
            description: "Total ways to draw 4 balls",
            value: "C(14,4) = 1001",
            importance: 8,
            x: -200, y: 0, z: 0
          },
          {
            id: "part_a_exactly_2_red",
            name: "Part (a): Exactly 2 Red",
            type: "steps",
            description: "Find ways to get exactly 2 red balls",
            value: "C(5,2) × C(9,2) = 10 × 36 = 360",
            importance: 9,
            x: 0, y: 0, z: 0
          },
          {
            id: "part_a_probability",
            name: "Part (a): Probability",
            type: "steps",
            description: "Calculate probability",
            value: "P(exactly 2 red) = 360/1001",
            importance: 8,
            x: 200, y: 0, z: 0
          },
          {
            id: "part_b_at_most_2_red",
            name: "Part (b): At Most 2 Red",
            type: "steps",
            description: "Find ways to get at most 2 red balls",
            value: "C(5,0)×C(9,4) + C(5,1)×C(9,3) + C(5,2)×C(9,2)",
            importance: 9,
            x: 0, y: 100, z: 0
          },
          {
            id: "part_b_calculation",
            name: "Part (b): Calculation",
            type: "steps",
            description: "Calculate each term",
            value: "126 + 420 + 360 = 906",
            importance: 8,
            x: 0, y: 150, z: 0
          },
          {
            id: "part_b_probability",
            name: "Part (b): Probability",
            type: "steps",
            description: "Calculate probability",
            value: "P(at most 2 red) = 906/1001",
            importance: 8,
            x: 0, y: 200, z: 0
          },
          {
            id: "final_answer",
            name: "Final Answer",
            type: "values",
            description: "Both probabilities",
            value: "(a) 360/1001 (b) 906/1001",
            importance: 10,
            x: 0, y: 250, z: 0
          }
        ],
        links: [
          { from: "ball_composition", to: "total_combinations", type: "enables", strength: 8 },
          { from: "ball_composition", to: "part_a_exactly_2_red", type: "enables", strength: 9 },
          { from: "total_combinations", to: "part_a_probability", type: "enables", strength: 8 },
          { from: "part_a_exactly_2_red", to: "part_a_probability", type: "enables", strength: 8 },
          { from: "ball_composition", to: "part_b_at_most_2_red", type: "enables", strength: 9 },
          { from: "part_b_at_most_2_red", to: "part_b_calculation", type: "leads to", strength: 8 },
          { from: "part_b_calculation", to: "part_b_probability", type: "leads to", strength: 8 },
          { from: "part_a_probability", to: "final_answer", type: "contributes to", strength: 8 },
          { from: "part_b_probability", to: "final_answer", type: "contributes to", strength: 8 }
        ]
      }
    }
  ],
  
  sequences: [
    {
      id: 'hkdse2015_sequences_01',
      problem: "For any positive integer $n$, let $A(n) = 4n - 5$ and $B(n) = 10^{4n-5}$. (a) Express $A(1) + A(2) + A(3) + \\cdots + A(n)$ in terms of $n$. (b) Find the greatest value of $n$ such that $\\log[B(1)B(2)B(3)\\cdots B(n)] \\leq 8000$.",
      problemType: "sequences_logarithms",
      difficulty: "harder",
      description: "Arithmetic sequences with logarithmic functions",
      graphData: {
        nodes: [
          {
            id: "sequence_definitions",
            name: "Sequence Definitions",
            type: "concepts",
            description: "A(n) and B(n) functions",
            value: "A(n) = 4n - 5, B(n) = 10^(4n-5)",
            importance: 10,
            x: 0, y: -200, z: 0
          },
          {
            id: "part_a_arithmetic_sum",
            name: "Part (a): Arithmetic Sum",
            type: "steps",
            description: "Find sum of A(n) sequence",
            value: "Sum = n/2 × [A(1) + A(n)]",
            importance: 9,
            x: -200, y: 0, z: 0
          },
          {
            id: "part_a_calculate_a1",
            name: "Part (a): Calculate A(1)",
            type: "steps",
            description: "Find A(1)",
            value: "A(1) = 4×1 - 5 = -1",
            importance: 8,
            x: 0, y: 0, z: 0
          },
          {
            id: "part_a_calculate_an",
            name: "Part (a): Calculate A(n)",
            type: "steps",
            description: "Find A(n)",
            value: "A(n) = 4n - 5",
            importance: 8,
            x: 200, y: 0, z: 0
          },
          {
            id: "part_a_final_sum",
            name: "Part (a): Final Sum",
            type: "steps",
            description: "Calculate the sum",
            value: "Sum = n/2 × [-1 + (4n-5)] = n/2 × (4n-6) = 2n² - 3n",
            importance: 9,
            x: 0, y: 100, z: 0
          },
          {
            id: "part_b_logarithm_product",
            name: "Part (b): Logarithm of Product",
            type: "steps",
            description: "Find log of product B(1)B(2)...B(n)",
            value: "log[B(1)B(2)...B(n)] = log[10^(sum of A(n))]",
            importance: 9,
            x: 0, y: 150, z: 0
          },
          {
            id: "part_b_simplify",
            name: "Part (b): Simplify",
            type: "steps",
            description: "Simplify the logarithm",
            value: "log[10^(2n²-3n)] = 2n² - 3n",
            importance: 8,
            x: 0, y: 200, z: 0
          },
          {
            id: "part_b_inequality",
            name: "Part (b): Inequality",
            type: "steps",
            description: "Set up inequality",
            value: "2n² - 3n ≤ 8000",
            importance: 9,
            x: 0, y: 250, z: 0
          },
          {
            id: "part_b_solve",
            name: "Part (b): Solve",
            type: "steps",
            description: "Solve quadratic inequality",
            value: "2n² - 3n - 8000 ≤ 0",
            importance: 8,
            x: 0, y: 300, z: 0
          },
          {
            id: "part_b_find_n",
            name: "Part (b): Find n",
            type: "steps",
            description: "Find maximum n",
            value: "n ≤ 63.5, so maximum n = 63",
            importance: 9,
            x: 0, y: 350, z: 0
          },
          {
            id: "final_answer",
            name: "Final Answer",
            type: "values",
            description: "Sum and maximum n",
            value: "(a) 2n² - 3n (b) 63",
            importance: 10,
            x: 0, y: 400, z: 0
          }
        ],
        links: [
          { from: "sequence_definitions", to: "part_a_arithmetic_sum", type: "enables", strength: 9 },
          { from: "part_a_arithmetic_sum", to: "part_a_calculate_a1", type: "enables", strength: 8 },
          { from: "part_a_calculate_a1", to: "part_a_calculate_an", type: "enables", strength: 8 },
          { from: "part_a_calculate_an", to: "part_a_final_sum", type: "enables", strength: 9 },
          { from: "part_a_final_sum", to: "part_b_logarithm_product", type: "enables", strength: 9 },
          { from: "part_b_logarithm_product", to: "part_b_simplify", type: "leads to", strength: 8 },
          { from: "part_b_simplify", to: "part_b_inequality", type: "leads to", strength: 9 },
          { from: "part_b_inequality", to: "part_b_solve", type: "leads to", strength: 8 },
          { from: "part_b_solve", to: "part_b_find_n", type: "leads to", strength: 9 },
          { from: "part_a_final_sum", to: "final_answer", type: "contributes to", strength: 9 },
          { from: "part_b_find_n", to: "final_answer", type: "contributes to", strength: 9 }
        ]
      }
    }
  ],
  
  quadratic_advanced: [
    {
      id: 'hkdse2015_quadratic_advanced_01',
      problem: "Let $f(x) = 2x^2 - 4kx + 3k^2 + 5$, where $k$ is a constant. (a) Does the graph of $y = f(x)$ intersect the $x$-axis? Explain your answer. (b) Using the method of completing the square, express the coordinates of the vertex of the graph of $y = f(x)$ in terms of $k$. (c) In the same rectangular coordinate system, let $S$ and $T$ be the moving points on the graphs of $y = f(x)$ and $y = 2 - f(x)$ respectively. Let the origin be $O$. Someone claims that when $S$ and $T$ are closest, the circumcenter of $\\triangle OST$ lies on the $x$-axis. Is this claim correct? Explain your answer.",
      problemType: "quadratic_advanced_geometry",
      difficulty: "harder",
      description: "Advanced quadratic functions with geometry",
      graphData: {
        nodes: [
          {
            id: "quadratic_function",
            name: "Quadratic Function",
            type: "concepts",
            description: "f(x) = 2x² - 4kx + 3k² + 5",
            value: "f(x) = 2x² - 4kx + 3k² + 5",
            importance: 10,
            x: 0, y: -200, z: 0
          },
          {
            id: "part_a_discriminant",
            name: "Part (a): Discriminant",
            type: "steps",
            description: "Find discriminant of f(x)",
            value: "Δ = b² - 4ac = (-4k)² - 4×2×(3k²+5)",
            importance: 9,
            x: -200, y: 0, z: 0
          },
          {
            id: "part_a_calculate_discriminant",
            name: "Part (a): Calculate Discriminant",
            type: "steps",
            description: "Calculate the discriminant",
            value: "Δ = 16k² - 8(3k²+5) = 16k² - 24k² - 40 = -8k² - 40",
            importance: 8,
            x: 0, y: 0, z: 0
          },
          {
            id: "part_a_conclusion",
            name: "Part (a): Conclusion",
            type: "steps",
            description: "Does it intersect x-axis?",
            value: "Δ < 0 for all k, so no real roots",
            importance: 9,
            x: 200, y: 0, z: 0
          },
          {
            id: "part_b_completing_square",
            name: "Part (b): Completing Square",
            type: "steps",
            description: "Complete the square",
            value: "f(x) = 2(x² - 2kx) + 3k² + 5",
            importance: 8,
            x: 0, y: 100, z: 0
          },
          {
            id: "part_b_further_complete",
            name: "Part (b): Further Complete",
            type: "steps",
            description: "Continue completing square",
            value: "f(x) = 2(x² - 2kx + k² - k²) + 3k² + 5",
            importance: 8,
            x: 0, y: 150, z: 0
          },
          {
            id: "part_b_final_form",
            name: "Part (b): Final Form",
            type: "steps",
            description: "Write in vertex form",
            value: "f(x) = 2(x-k)² + k² + 5",
            importance: 9,
            x: 0, y: 200, z: 0
          },
          {
            id: "part_b_vertex",
            name: "Part (b): Vertex",
            type: "steps",
            description: "Find vertex coordinates",
            value: "Vertex = (k, k² + 5)",
            importance: 9,
            x: 0, y: 250, z: 0
          },
          {
            id: "part_c_geometry_analysis",
            name: "Part (c): Geometry Analysis",
            type: "steps",
            description: "Analyze the geometric claim",
            value: "Find when S and T are closest",
            importance: 8,
            x: 0, y: 300, z: 0
          },
          {
            id: "part_c_circumcenter",
            name: "Part (c): Circumcenter",
            type: "steps",
            description: "Check if circumcenter lies on x-axis",
            value: "Verify the claim",
            importance: 8,
            x: 0, y: 350, z: 0
          },
          {
            id: "final_answer",
            name: "Final Answer",
            type: "values",
            description: "All required answers",
            value: "(a) No (b) (k, k²+5) (c) Claim verification",
            importance: 10,
            x: 0, y: 400, z: 0
          }
        ],
        links: [
          { from: "quadratic_function", to: "part_a_discriminant", type: "enables", strength: 9 },
          { from: "part_a_discriminant", to: "part_a_calculate_discriminant", type: "leads to", strength: 8 },
          { from: "part_a_calculate_discriminant", to: "part_a_conclusion", type: "leads to", strength: 9 },
          { from: "quadratic_function", to: "part_b_completing_square", type: "enables", strength: 8 },
          { from: "part_b_completing_square", to: "part_b_further_complete", type: "leads to", strength: 8 },
          { from: "part_b_further_complete", to: "part_b_final_form", type: "leads to", strength: 9 },
          { from: "part_b_final_form", to: "part_b_vertex", type: "leads to", strength: 9 },
          { from: "part_b_vertex", to: "part_c_geometry_analysis", type: "enables", strength: 8 },
          { from: "part_c_geometry_analysis", to: "part_c_circumcenter", type: "enables", strength: 8 },
          { from: "part_a_conclusion", to: "final_answer", type: "contributes to", strength: 9 },
          { from: "part_b_vertex", to: "final_answer", type: "contributes to", strength: 9 },
          { from: "part_c_circumcenter", to: "final_answer", type: "contributes to", strength: 8 }
        ]
      }
    }
  ],
  
  geometry_3d: [
    {
      id: 'hkdse2015_geometry_3d_01',
      problem: "In Figure 3(a), $ABCDB'$ is a pentagonal cardboard. Given that $AB = AB' = 40$ cm, $BC = B'D = 24$ cm and $\\angle ABC = \\angle AB'D = 80°$. (a) Suppose $105° \\leq \\angle BCD \\leq 145°$. (i) Find the distance between $A$ and $C$. (ii) Find $\\angle ACB$. (iii) Describe how the area of the cardboard changes when $\\angle BCD$ increases from $105°$ to $145°$. Explain your answer. (b) Suppose $\\angle BCD = 132°$. The cardboard in Figure 3(a) is folded along $AC$ and $AD$ so that $AB$ and $AB'$ are joined to form the triangular pyramid $ABCD$, as shown in Figure 3(b). Find the volume of the triangular pyramid $ABCD$.",
      problemType: "geometry_3d_pyramid",
      difficulty: "harder",
      description: "3D geometry with folding and volume",
      graphData: {
        nodes: [
          {
            id: "pentagon_properties",
            name: "Pentagon Properties",
            type: "concepts",
            description: "ABCDB' pentagon with given measurements",
            value: "AB = AB' = 40 cm, BC = B'D = 24 cm, ∠ABC = ∠AB'D = 80°",
            importance: 10,
            x: 0, y: -200, z: 0
          },
          {
            id: "part_a_i_cosine_law",
            name: "Part (a)(i): Cosine Law",
            type: "steps",
            description: "Find AC using cosine law",
            value: "AC² = AB² + BC² - 2×AB×BC×cos(∠ABC)",
            importance: 9,
            x: -200, y: 0, z: 0
          },
          {
            id: "part_a_i_calculation",
            name: "Part (a)(i): Calculation",
            type: "steps",
            description: "Calculate AC",
            value: "AC² = 40² + 24² - 2×40×24×cos(80°)",
            importance: 8,
            x: 0, y: 0, z: 0
          },
          {
            id: "part_a_i_result",
            name: "Part (a)(i): Result",
            type: "steps",
            description: "Find AC",
            value: "AC ≈ 42.3 cm",
            importance: 8,
            x: 200, y: 0, z: 0
          },
          {
            id: "part_a_ii_sine_law",
            name: "Part (a)(ii): Sine Law",
            type: "steps",
            description: "Find ∠ACB using sine law",
            value: "sin(∠ACB)/AB = sin(∠ABC)/AC",
            importance: 8,
            x: 0, y: 100, z: 0
          },
          {
            id: "part_a_ii_calculation",
            name: "Part (a)(ii): Calculation",
            type: "steps",
            description: "Calculate ∠ACB",
            value: "∠ACB ≈ 67.4°",
            importance: 8,
            x: 0, y: 150, z: 0
          },
          {
            id: "part_a_iii_area_analysis",
            name: "Part (a)(iii): Area Analysis",
            type: "steps",
            description: "Analyze area change",
            value: "Area increases as ∠BCD increases",
            importance: 8,
            x: 0, y: 200, z: 0
          },
          {
            id: "part_b_pyramid_volume",
            name: "Part (b): Pyramid Volume",
            type: "steps",
            description: "Find volume of triangular pyramid",
            value: "V = (1/3) × base area × height",
            importance: 9,
            x: 0, y: 250, z: 0
          },
          {
            id: "part_b_base_area",
            name: "Part (b): Base Area",
            type: "steps",
            description: "Find area of base triangle",
            value: "Use Heron's formula or trigonometry",
            importance: 8,
            x: 0, y: 300, z: 0
          },
          {
            id: "part_b_height",
            name: "Part (b): Height",
            type: "steps",
            description: "Find height of pyramid",
            value: "Use 3D geometry",
            importance: 8,
            x: 0, y: 350, z: 0
          },
          {
            id: "final_answer",
            name: "Final Answer",
            type: "values",
            description: "All required answers",
            value: "(a)(i) 42.3 cm (a)(ii) 67.4° (a)(iii) Increases (b) Volume = calculated value",
            importance: 10,
            x: 0, y: 400, z: 0
          }
        ],
        links: [
          { from: "pentagon_properties", to: "part_a_i_cosine_law", type: "enables", strength: 9 },
          { from: "part_a_i_cosine_law", to: "part_a_i_calculation", type: "leads to", strength: 8 },
          { from: "part_a_i_calculation", to: "part_a_i_result", type: "leads to", strength: 8 },
          { from: "part_a_i_result", to: "part_a_ii_sine_law", type: "enables", strength: 8 },
          { from: "part_a_ii_sine_law", to: "part_a_ii_calculation", type: "leads to", strength: 8 },
          { from: "part_a_ii_calculation", to: "part_a_iii_area_analysis", type: "enables", strength: 8 },
          { from: "part_a_iii_area_analysis", to: "part_b_pyramid_volume", type: "enables", strength: 9 },
          { from: "part_b_pyramid_volume", to: "part_b_base_area", type: "enables", strength: 8 },
          { from: "part_b_base_area", to: "part_b_height", type: "enables", strength: 8 },
          { from: "part_a_i_result", to: "final_answer", type: "contributes to", strength: 8 },
          { from: "part_a_ii_calculation", to: "final_answer", type: "contributes to", strength: 8 },
          { from: "part_a_iii_area_analysis", to: "final_answer", type: "contributes to", strength: 8 },
          { from: "part_b_height", to: "final_answer", type: "contributes to", strength: 8 }
        ]
      }
    }
  ]
}; 